/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateRelationshipRequest
 */
export interface CreateRelationshipRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateRelationshipRequest
     */
    sourceEntityType?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateRelationshipRequest
     */
    sourceEntityId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateRelationshipRequest
     */
    targetEntityType?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateRelationshipRequest
     */
    targetEntityId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateRelationshipRequest
     */
    relationshipType?: string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof CreateRelationshipRequest
     */
    metadata?: { [key: string]: any; };
}

/**
 * Check if a given object implements the CreateRelationshipRequest interface.
 */
export function instanceOfCreateRelationshipRequest(value: object): value is CreateRelationshipRequest {
    return true;
}

export function CreateRelationshipRequestFromJSON(json: any): CreateRelationshipRequest {
    return CreateRelationshipRequestFromJSONTyped(json, false);
}

export function CreateRelationshipRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateRelationshipRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'sourceEntityType': json['sourceEntityType'] == null ? undefined : json['sourceEntityType'],
        'sourceEntityId': json['sourceEntityId'] == null ? undefined : json['sourceEntityId'],
        'targetEntityType': json['targetEntityType'] == null ? undefined : json['targetEntityType'],
        'targetEntityId': json['targetEntityId'] == null ? undefined : json['targetEntityId'],
        'relationshipType': json['relationshipType'] == null ? undefined : json['relationshipType'],
        'metadata': json['metadata'] == null ? undefined : json['metadata'],
    };
}

export function CreateRelationshipRequestToJSON(json: any): CreateRelationshipRequest {
    return CreateRelationshipRequestToJSONTyped(json, false);
}

export function CreateRelationshipRequestToJSONTyped(value?: CreateRelationshipRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'sourceEntityType': value['sourceEntityType'],
        'sourceEntityId': value['sourceEntityId'],
        'targetEntityType': value['targetEntityType'],
        'targetEntityId': value['targetEntityId'],
        'relationshipType': value['relationshipType'],
        'metadata': value['metadata'],
    };
}

